import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
import AmountInstallments from '../AmountInstallments';
import RowTitle from '../RowTitle';
import { ArrowLeft2 } from 'iconsax-react';
import Outline from 'components/Button/Outline';
import Contained from 'components/Button/Contained';
import {SalaryMsg} from "../../../../Installments/Components/InstallmentsMsg";
import BottomSheet from "../../../../../components/BottomSheet";
import { useState } from 'react';

const useStyle = makeStyles(() => ({
	root: {
		width: '100%',
		borderRadius: '16px',
		border: '1px solid #D4D3E0',
		padding: '12px',
		backgroundColor: '#fff',
	},
	titleInstallment: {
		color: '#093B7C',
		fontSize: '14px',
		fontWeight: 700,
	},
	status: {
		fontSize: '12px',
		fontWeight: 700,
		marginTop: '4px',
	},
	hrDashed: {
		width: '100%',
		border: '1px dashed #E9E9F0',
		margin: '16px 0',
	},
}));

const CardDetail = ({moreDetail}) => {
	const classes = useStyle();
	const [isSalaryMsgOpen , setSalaryMsgOpen] = useState(false);
	const Status = ({ status }) => {
		switch (status) {
			case 'pending':
				return (
					<Typography style={{ color: '#EE7938' }} className={classes.status}>
						{' '}
						در انتظار پرداخت
					</Typography>
				);
			case 'success':
				return (
					<Typography style={{ color: '#14AC88' }} className={classes.status}>
						{' '}
						پرداخت شده
					</Typography>
				);
			default:
				return null;
		}
	};

	return (
		<Grid container className={classes.root}>
			<Grid item xs={12} style={{display: "flex",justifyContent: "space-between"}}>
				<Box>
				<Typography className={classes.titleInstallment}>اقساط دوره اسفند</Typography>
				<Status status={'success'} />
				</Box>
				<Box display="flex" alignItems="center" color="#0184FD">
						<Typography style={{fontSize: 14 , fontWeight: 700}}>
						مشاهده جزئیات اقساط
						</Typography>
						<ArrowLeft2 size={16} />
				</Box>
			</Grid>
			
			
				<Box className={classes.hrDashed} />
			<Grid item xs={12}>
				<AmountInstallments hasOverDue={false}/>
			</Grid>
			{

			}
			<Grid container style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16  }}>
						<Grid xs={5} item>
							
						<BottomSheet
					style={{ width: '100%', padding: 0, margin: 0 }}
					Component={
						<Box width={'100%'} p={'24px'}>
							<SalaryMsg onClose={() => setSalaryMsgOpen(false)}/>
						</Box>
					}
					button={
						<Outline onClick={() => setSalaryMsgOpen(true)}> کسر از حقوق</Outline>
					}
					openSheet={isSalaryMsgOpen}
					/>
						</Grid>
						<Grid xs={6} item>
							<Contained>پرداخت آنلاین</Contained>
						</Grid>
					</Grid>
			{
				moreDetail && 
				<>
				<Box className={classes.hrDashed} />
				<Grid item xs={12}>
				<RowTitle title={'مبلغ قابل پرداخت:'} online />
			</Grid>
				</>
			
			}
			
		</Grid>
	);
};

export default CardDetail;
